import Power from "../../shared/Power/Power";
import { Typography, message } from "antd";
import { useHistory } from "react-router-dom";
import React, { useState, useEffect } from "react";
import { updateBlogPostsShareCount } from "../../redux/actions/postAction";
import { connect } from "react-redux";
import ArticleIcons from "./ArticleCard/ArticleIcons";
import Tags from "./ArticleCard/Tags";
import Header from "./ArticleCard/Header";
import Share from "../mini/Share";
import { modalState } from "../../redux/actions/modalAction";
import { useAuthStore } from "../../store/AuthStore";
import { bookmarkPostAPI, unBookmarkPostAPI } from "../../api/BookmarkPost";
import { useMutation } from "@tanstack/react-query";
import { queryClient } from "../../index";
import dayjs from "dayjs";

const { Paragraph } = Typography;

const ArticleCard = ({
  modalState,
  post,
  isBookmarkTab,
  isMyPostTab,
  updateBlogPostsShareCount,
}) => {
  const history = useHistory();
  const { isLoggedIn } = useAuthStore();

  const [showShare, setShowShare] = useState(false);
  const [desc, setDesc] = useState("");

  useEffect(() => {
    if (post?.sections.length > 0) {
      const textValue = post?.sections.find((x) => x.type === "text");
      if (textValue !== undefined) {
        const htmlString = textValue.value;
        const text = htmlString.replace(/<[^>]+>|&nbsp;/g, "");
        setDesc(text);
      }
    }
  }, [post.sections]);

  const { mutate: bookmark } = useMutation({
    mutationFn: (postId) => bookmarkPostAPI(postId),
    onSuccess: () => {
      message.success("Bookmarked Successfully");
      queryClient.invalidateQueries({ queryKey: ["GetBookmarks"] });
      queryClient.invalidateQueries({ queryKey: ["GetBlogPosts"] });
    },
  });

  const { mutate: unBookmark } = useMutation({
    mutationFn: (postId) => unBookmarkPostAPI(postId),
    onSuccess: () => {
      message.success("Removed Bookmark Successfully");
      queryClient.invalidateQueries({ queryKey: ["GetBookmarks"] });
      queryClient.invalidateQueries({ queryKey: ["GetBlogPosts"] });
    },
  });

  const onRoute = (e, page) => {
    e.stopPropagation();

    history.push(`/blogfolio/${post.blog.urlSlug}/${page}`);
  };

  const searchByTag = (e, tag_name) => {
    e.stopPropagation();
    history.push(`/search/1/posts/${tag_name}`);
  };

  const removeBookmark = (e) => {
    e.stopPropagation();

    if (!isLoggedIn) {
      modalState(true);
      return;
    }
    unBookmark(post.id);
  };

  const handleBookmark = (e) => {
    e.stopPropagation();

    if (!isLoggedIn) {
      modalState(true);
      return;
    }

    if (post.isBookmarked) {
      unBookmark(post.id);
    } else {
      bookmark(post.id);
    }
  };

  const hideShareModal = () => {
    updateBlogPostsShareCount(post?.id);
    setShowShare(false);
  };

  const handleShare = (e) => {
    e.stopPropagation();
    setShowShare(true);
  };

  const handleFlagging = (e) => {
    e.stopPropagation();
    // updateBlogPostFlagging(post?.id);
  };

  const getMedia = () => {
    if (post?.imageUrl) {
      return post?.imageUrl;
    } else if (post?.sections?.length && post?.sections[0].value) {
      return post?.sections[0].value;
    } else {
      return window.location.href;
    }
  };

  const handleGoToViewPost = () => {
    history.push(`/viewpost/${post?.urlSlug}`);
  };

  return (
    <>
      {/* Desktop Screen */}
      <div className="home-article">
        <div className="top">
          <div className="content">
            <Header post={post} onRoute={onRoute} isMobile={false} />
            <Paragraph
              className="title"
              ellipsis={{ rows: 2 }}
              onClick={handleGoToViewPost}
            >
              {post?.title}
            </Paragraph>
            <Paragraph className="desc" ellipsis={{ rows: 2 }}>
              {desc}
            </Paragraph>
            <Tags post={post} searchByTag={searchByTag} isMobile={false} />
          </div>
          {post?.imageUrl && (
            <div className="image" onClick={handleGoToViewPost}>
              <img src={encodeURI(post?.imageUrl)} alt="" />
            </div>
          )}
        </div>

        <div className="bottom">
          <Power count={post?.powerScore} isViewPost={true} />
          <ArticleIcons
            post={post}
            handleBookmark={handleBookmark}
            handleShare={handleShare}
            handleFlagging={handleFlagging}
            isBookmarkTab={isBookmarkTab}
            isMyPostTab={isMyPostTab}
            removeBookmark={removeBookmark}
          />
        </div>
      </div>

      {/* Mobile Screen */}
      <div className="home-article-mob">
        <Header post={post} onRoute={onRoute} isMobile={true} />

        <div className="content">
          <div className="left">
            <Paragraph
              className="title"
              ellipsis={{ rows: 3 }}
              onClick={handleGoToViewPost}
            >
              {post?.title}
            </Paragraph>
            <p
              style={{
                fontSize: "0.75rem",
                color: "#647490",
              }}
            >
              {dayjs(post?.updatedAt).format("DD MMM YYYY")}
            </p>
          </div>

          {post?.imageUrl && (
            <div className="image" onClick={handleGoToViewPost}>
              <img src={encodeURI(post?.imageUrl)} alt="" />
            </div>
          )}
        </div>
        <Tags post={post} searchByTag={searchByTag} isMobile={true} />
        <div className="bottom">
          <Power count={post?.powerScore} isViewPost={true} />
          <ArticleIcons
            post={post}
            handleBookmark={handleBookmark}
            handleShare={handleShare}
            handleFlagging={handleFlagging}
            isBookmarkTab={isBookmarkTab}
            isMyPostTab={isMyPostTab}
            removeBookmark={removeBookmark}
          />
        </div>
      </div>

      {/* Share Modal */}
      <Share
        url={`/viewpost/${post?.urlSlug}`}
        show={showShare}
        hide={hideShareModal}
        media={getMedia()}
      />
    </>
  );
};

const mapStateToProps = (state) => ({});

export default connect(mapStateToProps, {
  updateBlogPostsShareCount,
  modalState,
})(ArticleCard);
